import { ItemPrice } from '@kinet-open-network/client/item-prices/data-access';
import { BaseModel } from '@kinet-open-network/client/shared/data-access/model';
import {
  DeviceType,
  IStockItem,
  IStockItemBalance,
} from '@kinet-open-network/shared/data-access/model';
import { Type } from 'class-transformer';

export class StockItem
  extends BaseModel<StockItem, 'StockItem'>
  implements IStockItem
{
  static override readonly modelName = 'StockItem';

  name!: string;
  description?: string | undefined;
  sku!: string;
  parentId?: string;
  parent?: IStockItem | undefined;
  @Type(() => Boolean)
  trackSn!: boolean;
  stockItem?: StockItem | null;
  @Type(() => Number)
  salePrice?: number;
  @Type(() => Number)
  rentPrice?: number;
  sn?: string;
  mac?: string;
  type?: DeviceType;
  groupId?: string;
  balances!: IStockItemBalance[];

  @Type(() => ItemPrice)
  prices?: ItemPrice[];
}
